import PortalRadioButtonGroup from './PortalRadioButtonGroup.js';

export default PortalRadioButtonGroup;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalRadioButtonGroup/index.js